/** @format */

import Logout from "./Logout";
import { BBLogin } from "./bbOauth/BBLogin";
import { HwbLogin } from "./hwbAuth/HwbLogin";

const authRoutes = [
  {
    path: "bblogin",
    element: <BBLogin />,
  },
  {
    path: `hwblogin`,
    element: <HwbLogin />,
  },
  {
    path: "logout",
    element: <Logout />,
  },
];

export default authRoutes;
